import { render, staticRenderFns } from "./PictureComponent.vue?vue&type=template&id=b0507070&"
import script from "./PictureComponent.vue?vue&type=script&lang=ts&"
export * from "./PictureComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports